<template>
  <LoadingData v-if="isLoadingData" />
  <div v-else class="card login-form mb-0">
    <div class="card-body">
      <div class="text-center mb-3">
        <img src="@/assets/img/logo_nextgen.png" class="h-72px" />
        <h5 class="mt-1 mb-1">Bem-vindo</h5>
      </div>
      <div>
        <button
          type="button"
          class="btn btn-primary w-100"
          title="Iniciar Formulário"
          @click="initForm"
        >
          <span>Iniciar Formulário</span>
        </button>
        <hr />
        <div class="text-center" title="Cancelar">
          <router-link to="/">Cancelar</router-link>
        </div>
        <p class="mt-2 mb-0 text-center">Powered by Ethos</p>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'Form',

  components: {
    LoadingData,
  },

  data() {
    return {
      isLoadingData: true,
    }
  },

  computed: {
    ...mapGetters(['forms', 'order']),
  },

  methods: {
    async getForms() {
      try {
        await this.$store.dispatch('getForms')
        this.isLoadingData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async initForm() {
      const form = this.forms.find(
        (form) => Number(form.ordering) === this.order,
      )

      const nextOrder = this.order === this.forms.length ? 1 : this.order + 1
      await this.$store.dispatch('changeOrder', nextOrder)

      this.$router.push({
        name: 'Register',
        params: { code: form.code },
      })
    },
  },

  mounted() {
    this.$store.dispatch('logout').then(() => {
      this.getForms()
    })
  },
}
</script>
